import { render } from "./FocusEng.vue?vue&type=template&id=081b3d35"
import script from "./FocusEng.vue?vue&type=script&lang=js"
export * from "./FocusEng.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__